<div class="modal-header">
    here title
    <button type="button" class="close pull-right" aria-label="Close" onClick="close()">
        <div class="close-modal" aria-hidden="true"></div>
    </button>
</div>
<div class="modal-body">
    <div #container></div>
</div>
<div class="modal-footer">
   <button class="btn btn-success"onClick="submit()">Submit</button>
</div>